import React from 'react';
import { connect } from 'react-redux';
import { Alert, Card, CardBody } from 'reactstrap';

interface ErrorBoundaryProps extends React.PropsWithChildren {
  hasError?: boolean;
  error?: Error;
}

const ErrorBoundary: React.FunctionComponent<ErrorBoundaryProps> = ({
  hasError,
  error,
  children,
}) => {
  if (hasError && error) {
    return (
      <div id="content">
        <Card>
          <CardBody>
            <h2>Oj hoppsan!</h2>
            <p>
              Pinsamt, det här skall aldrig ske.
              <ul>
                <li>Du kan behöva ladda om sidan för att fortsätta arbeta.</li>
                <li>
                  Rutan nedan kan tillsammans med en beskrivning av vad du
                  gjorde när felet inträffade skickas med fördel till:
                  <a
                    href={`mailto:hello@flaivy.com?subject=Krash i flaivy&body=${error.message}%0A${error.stack}`}
                    target="_blank"
                  >
                    hello@flaivy.com
                  </a>
                </li>
              </ul>
            </p>
            <Alert color="danger">
              <strong>{error.message}</strong>
              <pre>{error.stack}</pre>
            </Alert>
          </CardBody>
        </Card>
      </div>
    );
  }

  // Return children components in case of no error

  return <>{children}</>;
};

const mapStateToProps = ({ errorBoundary }: any) => ({
  ...errorBoundary,
});

export default connect(mapStateToProps)(ErrorBoundary);
